'use strict';

import Api from "./Api";

export default class Direction extends Api {

    static getList(page = 1, perPage = 10, sort = undefined, extraFields = []) {
        const url = this.url + 'direction-salary-scheme/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                sort: sort,
                expand: extraFields.join(','),
            },
        });
    }

    static get(id) {
        const url = this.url + 'direction-salary-scheme/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'direction-salary-scheme/add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'direction-salary-scheme/update';

        return this.getAxios().post(url, data);
    }

    static remove(data) {
        const url = this.url + 'direction-salary-scheme/remove';

        return this.getAxios().post(url, data);
    }

}